<template>
  <div class="footer">
    <div class="">
      <img
        class="footerLogo"
        src="@/assets/mobile/navigation/navigation-logo.png"
        alt=""
      />
      <div class="menuList">
        <div class="product menuItem">
          <div class="itemTitle">{{ $t('publicFooter.products') }}</div>
          <ul class="itemList">
            <!-- <li>{{ $t('publicFooter.product1') }}</li>
            <li>{{ $t('publicFooter.product2') }}</li>
            <li>{{ $t('publicFooter.product3') }}</li>
            <li>{{ $t('publicFooter.product4') }}</li>
            <li>{{ $t('publicFooter.product5') }}</li> -->
            <li
              v-for="(item, index) in productList"
              :key="index"
              @click="jump(item.routeName)"
            >
              {{ $t(`publicFooter.${item.text}`) }}
            </li>
          </ul>
        </div>
        <div class="solutions menuItem">
          <div class="itemTitle">{{ $t('publicFooter.solutions') }}</div>
          <ul class="itemList">
            <li>{{ $t('publicFooter.solutions1') }}</li>
            <li>{{ $t('publicFooter.solutions2') }}</li>
          </ul>
        </div>
        <div class="company menuItem">
          <div class="itemTitle">{{ $t('publicFooter.company') }}</div>
          <ul class="itemList">
            <li @click="jump('company')">{{ $t('publicFooter.company1') }}</li>
          </ul>
        </div>
        <div class="contact menuItem">
          <div class="itemTitle">{{ $t('publicFooter.contactUs') }}</div>
          <ul class="itemList">
            <li>
              {{ $t('publicFooter.contactUs2') }}
              <a
                v-if="$i18n.locale === 'id'"
                href="mailto:Support_info@cloudun.ai"
              >
                : Support_info@cloudun.ai
              </a>
              <a v-else href="mailto:operation@cloudun.ai">
                : operation@cloudun.ai
              </a>
            </li>

            <!-- <li>{{ $t('publicFooter.contactUs1') }}: +62 877 75637420</li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="batch">
      <div class="myMai">©Copyright Cloudun PTE. LTD</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      productList: [
        {
          text: 'product1',
          routeName: 'aiAds'
        },
        {
          text: 'product2',
          routeName: 'ekyc'
        },
        {
          text: 'product3',
          routeName: 'lunaAi'
        },
        {
          text: 'product4',
          routeName: 'antiFraud'
        },
        {
          text: 'product5',
          routeName: 'creditScore'
        }
      ]
    }
  },
  created () {
    this.isIds()
  },
  methods: {
    jump (name) {
      if (name !== this.$route.name) {
        this.$router.push({ name })
      } else {
        window.scrollTo(0, 0)
      }
    },
    isIds () {
      if (this.$i18n.locale === 'id') {
        this.productList = this.productList.filter(item =>
          item.routeName === 'creditScore' || item.routeName === 'antiFraud'
        )
      }
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  background-color: #fff;
  text-align: left;
}
.footerLogo {
  width: 4rem /* 150/37.5 */;
  margin: 0.8rem /* 30/37.5 */ 0 0.2rem 0;
  padding-left: 0.426667rem; /* 16/37.5 */
}
.menuList {
  padding-left: 0.96rem /* 36/37.5 */;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 0.8rem /* 30/37.5 */;
  > div {
    height: 100%;
  }
  .menuItem {
    .itemTitle {
      font-size: 0.426667rem /* 16/37.5 */;
      color: #2e3433;
      margin: 0.266667rem /* 10/37.5 */ 0;
      font-weight: 500;
      font-weight: 500;
    }
    .itemList {
      cursor: pointer;
      li {
        color: #929594;
        font-size: 0.32rem /* 12/37.5 */;
        line-height: 0.52rem;
        font-weight: 400;
        // margin-bottom: 0.24rem;
        a {
          color: #007660;
          font-weight: 500;
        }
      }
    }
  }
}
.batch {
  width: 100%;
  background: #f7f9f8;
  padding: 0.346667rem /* 13/37.5 */ 0;
  .myMai {
    text-align: center;
    color: rgba(36, 43, 42, 0.7);
    font-size: 0.32rem /* 12/37.5 */;
    font-weight: 400;
  }
}
</style>
